/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SaveAssetPersonalDataInventoryPart } from './SaveAssetPersonalDataInventoryPart';
import {
    SaveAssetPersonalDataInventoryPartFromJSON,
    SaveAssetPersonalDataInventoryPartFromJSONTyped,
    SaveAssetPersonalDataInventoryPartToJSON,
    SaveAssetPersonalDataInventoryPartToJSONTyped,
} from './SaveAssetPersonalDataInventoryPart';
import type { SaveAssetPersonalDataClientPart } from './SaveAssetPersonalDataClientPart';
import {
    SaveAssetPersonalDataClientPartFromJSON,
    SaveAssetPersonalDataClientPartFromJSONTyped,
    SaveAssetPersonalDataClientPartToJSON,
    SaveAssetPersonalDataClientPartToJSONTyped,
} from './SaveAssetPersonalDataClientPart';

/**
 * 
 * @export
 * @interface SaveAssetPersonalDataRequest
 */
export interface SaveAssetPersonalDataRequest {
    /**
     * 
     * @type {SaveAssetPersonalDataClientPart}
     * @memberof SaveAssetPersonalDataRequest
     */
    personalData: SaveAssetPersonalDataClientPart;
    /**
     * 
     * @type {SaveAssetPersonalDataInventoryPart}
     * @memberof SaveAssetPersonalDataRequest
     */
    assetInventory: SaveAssetPersonalDataInventoryPart;
}

/**
 * Check if a given object implements the SaveAssetPersonalDataRequest interface.
 */
export function instanceOfSaveAssetPersonalDataRequest(value: object): value is SaveAssetPersonalDataRequest {
    if (!('personalData' in value) || value['personalData'] === undefined) return false;
    if (!('assetInventory' in value) || value['assetInventory'] === undefined) return false;
    return true;
}

export function SaveAssetPersonalDataRequestFromJSON(json: any): SaveAssetPersonalDataRequest {
    return SaveAssetPersonalDataRequestFromJSONTyped(json, false);
}

export function SaveAssetPersonalDataRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveAssetPersonalDataRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'personalData': SaveAssetPersonalDataClientPartFromJSON(json['personalData']),
        'assetInventory': SaveAssetPersonalDataInventoryPartFromJSON(json['assetInventory']),
    };
}

export function SaveAssetPersonalDataRequestToJSON(json: any): SaveAssetPersonalDataRequest {
    return SaveAssetPersonalDataRequestToJSONTyped(json, false);
}

export function SaveAssetPersonalDataRequestToJSONTyped(value?: SaveAssetPersonalDataRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'personalData': SaveAssetPersonalDataClientPartToJSON(value['personalData']),
        'assetInventory': SaveAssetPersonalDataInventoryPartToJSON(value['assetInventory']),
    };
}

